<template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin: 0 auto; width: 100%">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>大棚告警记录</h4>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="大棚名称：">
            <el-cascader expand-trigger="hover" v-model="groupIdArr" :options="groupArray" :props="optionProps"
              @change="groupChange" placeholder="请选择大棚名称" collapse-tags clearable></el-cascader>
          </el-form-item>
          <el-form-item label="告警时间：">
            <el-date-picker v-model="alarmTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" align="right" value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss" clearable @change="handleSearch">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="大棚名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送人姓名">
              <template slot-scope="scope">
                <p>{{ scope.row.realName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送人账号">
              <template slot-scope="scope">
                <p>{{ scope.row.account }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送模式">
              <template slot-scope="scope">
                <p>{{ topushModel(scope.row.pushModel) }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警次数">
              <template slot-scope="scope">
                <p>告警{{ scope.row.alarmNum }}次</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="已发次数">
              <template slot-scope="scope">
                <p>已发{{ scope.row.alarmNumSend }}次</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警等级">
              <template slot-scope="scope">
                <p v-if="scope.row.level == 0" :style="'color:' + scope.row.color">轻微告警</p>
                <p v-if="scope.row.level == 1" :style="'color:' + scope.row.color">一般告警</p>
                <p v-if="scope.row.level == 2" :style="'color:' + scope.row.color">严重告警</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警内容" width="600">
              <template slot-scope="scope">
                <p>{{ scope.row.content }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="最后一次告警时间" width="200">
              <template slot-scope="scope">
                <p>{{ scope.row.alarmLastTime }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next, jumper" class="pageTap"
              @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize"
              :total="total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: "",
        startTime: "",
        endTime: "",
      },
      groupIdArr: [],
      alarmTime: [],
      total: 0, // 总数
      tableData: [],
      loading: false,
      groupArray: [], // 大棚名称数组
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
        multiple: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    // 获取分组列表
    this.getGroupList();

    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: "",
        startTime: "",
        endTime: "",
      };
      this.groupIdArr = [];
      this.alarmTime = [];
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      if (this.alarmTime && this.alarmTime.length == 2) {
        this.searchForm.startTime = this.alarmTime[0];
        this.searchForm.endTime = this.alarmTime[1];
      } else {
        this.searchForm.startTime = "";
        this.searchForm.endTime = "";
      }

      this.$api.groupAlarm
        .getGrowthModelGroupHisAlarmList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          }
          this.loading = false;
        });
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data;
        }
      });
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (
        !this.groupIdArr ||
        this.groupIdArr.length != 2
      ) {
        this.groupIdArr = [];
        this.searchForm.groupId = "";
      } else {
        this.searchForm.groupId = this.groupIdArr[1];
      }
      this.getList();
    },
    // 推送模型转名称
    topushModel(pm) {
      return pm == undefined || pm == null
        ? ""
        : pm
          .toString()
          .replace("0", "邮箱发送")
          .replace("1", "短信发送")
          .replace("2", "APP推送")
          .replace("3", "小程序推送")
          .replace("4", "语音拨号提醒");
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>